import { createContext } from "react";

/**
 * LIFF Context Type Definition
 * Shared between provider and consumer
 */
export interface LiffContextType {
  isLoggedIn: boolean;
  isLiffReady: boolean;
  userId: string | null;
  idToken: string | null;
  accessToken: string | null;
  error: Error | null;
  login: () => void;
  logout: () => void;
  closeWindow: () => void;
}

/**
 * LIFF Context
 * Created separately to avoid Fast Refresh issues
 */
export const LiffContext = createContext<LiffContextType | undefined>(
  undefined,
);
